export default __webpack_public_path__ + "static/media/research-graph.4ca55141.jpg";